module.exports = __webpack_public_path__ + "img/senchatouch.d1dd5cc6.svg";